/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Raffle_No_PlayersInputs */



/**
* | output |
* | --- |
* | "No eligible players in pool" |
*
* @param {Err_Tournament_Raffle_No_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_raffle_no_players = /** @type {((inputs?: Err_Tournament_Raffle_No_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Raffle_No_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun joueur éligible dans le pool")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay jugadores elegibles en el pool")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum jogador elegível no pool")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun giocatore idoneo nel pool")
	return /** @type {LocalizedString} */ ("No eligible players in pool")
});